// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"footer-languages-component_uk-open__Ia2Nc","grecaptcha-badge":"footer-languages-component_grecaptcha-badge__PzCcv","footerLanguages":"footer-languages-component_footerLanguages__UTZbL","title":"footer-languages-component_title__sYstt","list":"footer-languages-component_list__SYPSu"};
    if(module.hot) {
      // 1756311281021
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  